import { atomWithReset } from 'jotai/utils'

export const PASSWORD_DESIGN_SECTION_ID = 'password'

export const passwordEnabledAtom = atomWithReset(false)
export const passwordAtom = atomWithReset('')
export const passwordRepeatAtom = atomWithReset('')
export const passwordSubmitAttemptedAtom = atomWithReset(false)

// Id of the code whose server password savedPasswordAtom reflects (loaded or
// saved in this session), so a step 3 remount does not overwrite unsaved edits.
export const passwordLoadedForTargetAtom = atomWithReset<string | null>(null)

// Password last confirmed on the server for the code the builder is saving
// (draft in create mode, target in edit mode). null means no password.
// Held in memory only, never persisted.
export const savedPasswordAtom = atomWithReset<string | null>(null)

// Password last confirmed on the server for the draft (the `id` param), which
// is what step 3 restores after a reload. In create mode it is the same code
// as savedPasswordAtom; in edit mode savedPasswordAtom follows the live code.
// isAuthenticated records which endpoint it was read through.
export const draftPasswordAtom = atomWithReset<{
	qrId: string
	isAuthenticated: boolean
	password: string | null
} | null>(null)
